import { render, staticRenderFns } from "./TestAPI.vue?vue&type=template&id=446a28b1&scoped=true"
import script from "./TestAPI.vue?vue&type=script&lang=js"
export * from "./TestAPI.vue?vue&type=script&lang=js"
import style0 from "./TestAPI.vue?vue&type=style&index=0&id=446a28b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446a28b1",
  null
  
)

export default component.exports